import axios from "axios";
import {sendPostRequest} from "@k/global/axiosFormWrapper";
import {getUrlVars} from "@k/global/globalUtils";
import {GetParametersDecoded} from "@k/js/delme_globals";

export default {
    state: () => ({
        infoFromGetParameters: null as null|GetParametersDecoded
    }),
    getters: {
        getInfoFromGetParameters:(state)=>state.infoFromGetParameters,
    },
    mutations: {
        SET_INFO_FROM_GETPARAMETERS:(state, payload)=>state.infoFromGetParameters=payload
    },
    actions:{
        loadGetParametersCached:(context)=>{
            axios({
                url:"/konfigurator_php/mobile/getComputedGETparameters.php"+window.location.search,
            }).then(response=> context.dispatch("completeGetParameters", response.data))
        },
        completeGetParameters:(context, infoFromGetParametersCached)=>{
            sendPostRequest("/konfigurator_php/auswahlmodul/computeNonCachableParameters.php", {
                paramsSoFar:JSON.stringify(infoFromGetParametersCached),
                originalGetParameters:JSON.stringify(getUrlVars())
            }).then(response=>{
                context.commit("SET_INFO_FROM_GETPARAMETERS", response.data)
            })
        }
    }
}
